import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import './Official.css';

class PrivacyPolicy extends Component {

    componentDidMount() {
        // Hide loading overlay
        document.getElementById('LoadingOverlay').style.opacity = '0';

        // Update title
        document.title = 'Word Surge - Privacy Policy';

        // Stop propagation of touchmove on mount
        ReactDOM.findDOMNode(this).addEventListener('touchmove', (e) => {
            e.stopPropagation();
        }, false);
    }

    render() {
        return (
            <div className="OfficialWrapper">
                <div className="OfficialContainer">
                    <h1 className="Title">Privacy Policy</h1>
                    <p className="Paragraph">
                        Effective date: May 26, 2019
                    </p>
                    <p className="Paragraph">
                        This page informs you of our policies regarding the collection, use, and disclosure of personal data when you use our Service and the choices you have associated with that data.
                    </p>
                    <p className="Paragraph">
                        We use your data to improve the Service. By using the Service, you agree to the collection and use of information in accordance with this policy. Unless otherwise defined in this Privacy Policy, the terms used in this Privacy Policy have the same meanings as in our Terms and Conditions.
                    </p>
                    <h2 className="Subtitle">Information Collection And Use</h2>
                    <p className="Paragraph">
                        We collect several different types of information for various purposes to provide and improve our Service to you. Types of data collected include:
                    </p>
                    <h3 className="SectionHeader">Personal Data</h3>
                    <p className="Paragraph">
                        While using our Service, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you ("Personal Data"). Personally identifiable information may include, but is not limited to:
                    </p>
                    <ul>
                        <li>Cookies and Usage Data</li>
                    </ul>
                    <h3 className="SectionHeader">Usage Data</h3>
                    <p className="Paragraph">
                        When you access the Service with a mobile device, we may collect certain information automatically, including, but not limited to, the type of mobile device you use, your mobile device unique ID, the IP address of your mobile device, your mobile operating system, the type of mobile Internet browser you use, unique device identifiers and other diagnostic data ("Usage Data").
                    </p>
                    <h3 className="SectionHeader">Tracking & Cookies Data</h3>
                    <p className="Paragraph">
                        We use cookies and similar tracking technologies to track the activity on our Service and hold certain information.
                    </p>
                    <p className="Paragraph">
                        Cookies are files with small amount of data which may include an anonymous unique identifier. Cookies are sent to your browser from a website and stored on your device. Tracking technologies also used are beacons, tags, and scripts to collect and track information and to improve and analyze our Service.
                    </p>
                    <p className="Paragraph">
                        You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our Service.
                    </p>
                    <h2 className="Subtitle">Use of Data</h2>
                    <p className="Paragraph">
                        Word Surge uses the collected data for various purposes:
                    </p>
                    <ul>
                        <li>To provide and maintain the Service</li>
                        <li>To notify you about changes to our Service</li>
                        <li>To allow you to participate in interactive features of our Service when you choose to do so</li>
                        <li>To provide customer care and support</li>
                        <li>To provide analysis or valuable information so that we can improve the Service</li>
                        <li>To monitor the usage of the Service</li>
                        <li>To detect, prevent and address technical issues</li>
                    </ul>
                    <h2 className="Subtitle">Transfer of Data</h2>
                    <p className="Paragraph">
                        Your information, including Personal Data, may be transferred to — and maintained on — computers located outside of your state, province, country or other governmental jurisdiction where the data protection laws may differ than those from your jurisdiction.
                    </p>
                    <p className="Paragraph">
                        If you are located outside United States and choose to provide information to us, please note that we transfer the data, including Personal Data, to United States and process it there.
                    </p>
                    <p className="Paragraph">
                        Your consent to this Privacy Policy followed by your submission of such information represents your agreement to that transfer.
                    </p>
                    <p className="Paragraph">
                        Word Surge will take all steps reasonably necessary to ensure that your data is treated securely and in accordance with this Privacy Policy and no transfer of your Personal Data will take place to an organization or a country unless there are adequate controls in place including the security of your data and other personal information.
                    </p>
                    <h2 className="Subtitle">Disclosure of Data</h2>
                    <h3 className="SectionHeader">Legal Requirements</h3>
                    <p className="Paragraph">
                        Word Surge may disclose your Personal Data in the good faith belief that such action is necessary to:
                    </p>
                    <ul>
                        <li>To comply with a legal obligation</li>
                        <li>To protect and defend the rights or property of Word Surge</li>
                        <li>To prevent or investigate possible wrongdoing in connection with the Service</li>
                        <li>To protect the personal safety of users of the Service or the public</li>
                        <li>To protect against legal liability</li>
                    </ul>
                    <h2 className="Subtitle">Security Of Data</h2>
                    <p className="Paragraph">
                        The security of your data is important to us, but remember that no method of transmission over the Internet, or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your Personal Data, we cannot guarantee its absolute security.
                    </p>
                    <h2 className="Subtitle">Service Providers</h2>
                    <p className="Paragraph">
                        We employ third party companies and individuals to facilitate our Service ("Service Providers"), to provide the Service on our behalf, to perform Service-related services or to assist us in analyzing how our Service is used.
                    </p>
                    <p className="Paragraph">
                        These third parties have access to your Personal Data only to perform these tasks on our behalf and are obligated not to disclose or use it for any other purpose.
                    </p>
                    <h3 className="SectionHeader">Analytics</h3>
                    <p className="Paragraph">
                        We may use third-party Service Providers to monitor and analyze the use of our Service.
                    </p>
                    <ul>
                        <li>
                            Google Analytics
                            <ul>
                                <li>
                                    Google Analytics will collect information to provide better services to all users — for example:
                                    <ul>
                                        <li>which language you speak</li>
                                        <li>which ads you’ll find most useful</li>
                                        <li>which YouTube videos you might like</li>
                                        <li>which websites would be to your greatest benefit</li>
                                    </ul>
                                </li>
                                <li>
                                    The information Google collects, and how that information is used, depends on how you use our services and how you manage your privacy controls.
                                </li>
                                <li>
                                    When you’re not signed in to a Google Account, we store the information we collect with unique identifiers tied to the browser, application, or device you’re using. This helps us do things like maintain your language preferences across sessions.
                                </li>
                                <li>
                                    When you’re signed in, we also collect information that we store with your Google Account, which we treat as personal information.
                                </li>
                            </ul>
                        </li>
                    </ul>
                    <h2 className="Subtitle">Links to Other Sites</h2>
                    <p className="Paragraph">
                        Our Service may contain links to other sites that are not operated by us. If you click on a third party link, you will be directed to that third party's site. We strongly advise you to review the Privacy Policy of every site you visit.
                    </p>
                    <p className="Paragraph">
                        We have no control over and assume no responsibility for the content, privacy policies or practices of any third party sites or services.
                    </p>
                    <h2 className="Subtitle">Changes To This Privacy Policy</h2>
                    <p className="Paragraph">
                        We may update our Privacy Policy from time to time to reflect current events. We will notify you of any changes by posting the new Privacy Policy on this page.
                    </p>
                    <p className="Paragraph">
                        You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.
                    </p>
                    <h2 className="Subtitle">Contact Us</h2>
                    <p className="Paragraph">
                        If you have any questions about this Privacy Policy, please contact us:
                    </p>
                    <ul>
                        <li>
                            By email: contact@aidanbauer.me
                        </li>
                        <li>
                            By visiting this page on our website: http://aidanbauer.me
                        </li>
                    </ul>
                </div>
            </div>
        );
    }
}

export default PrivacyPolicy;
